import { ParameterType } from '@/study-search/enums';
import { FilterDefinition } from './FilterDefinition';

export abstract class PortalDefinition {
	public constructor(
		public readonly filterDefinitions: FilterDefinition[],
		public readonly topCountries: string[],
		public readonly titlePortalType: string,
		public readonly path: string,
		public readonly value: string,
		public readonly metaDescriptionPortalType: string
	) {}

	public exists(path: string): boolean {
		return this.filterDefinitions.map((_) => _.exists(path)).reduce((previous, current) => previous || current);
	}

	public getFilterDefinition(filterType: string): FilterDefinition {
		const filterDefinition = this.filterDefinitions.find((_) => _.type === (filterType as ParameterType));
		if (filterDefinition !== undefined) {
			return filterDefinition;
		}

		throw new Error('Filter type definition does not exist');
	}

	public isValidFilter(filterType: string): boolean {
		return this.filterDefinitions.find((_) => _.type === (filterType as ParameterType)) !== undefined;
	}

	public isFilterRequired(key: ParameterType): boolean {
		const filterDefinition = this.filterDefinitions.find((_) => _.type === key);
		if (!filterDefinition) {
			return false;
		}

		return filterDefinition.isRequired;
	}
}
